module.exports = __webpack_public_path__ + "img/monarch-ui-icon_GENE.86a0b6ff.png";